var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-wrapper",on:{"click":_vm.goToFrontpage}},[_c('svg-icon',{attrs:{"icon":`ng-logo-nabogo`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }